import { apiClient } from './client';

export const pushApi = {
  publicKey: async () => {
    const res = await apiClient.get('/push/public-key');
    return res.data.data as { enabled: boolean; publicKey: string | null };
  },

  subscribe: async (sub: PushSubscriptionJSON) => {
    await apiClient.post('/push/subscribe', sub);
  },

  unsubscribe: async (endpoint: string) => {
    await apiClient.delete('/push/subscribe', { data: { endpoint } });
  },

  /** Server-sent test push — proves delivery works with the tab closed. */
  test: async () => {
    const res = await apiClient.post('/push/test');
    return res.data.data as { sent: number };
  },
};
